// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"75efed4b","418":"585126c0","667":"c8c5b7d8","690":"58c22f99","811":"7dc31db4"}[chunkId] + ".chunk.css";
};